/* Structured article — auto-generated table of contents + mobile header offset */
(function () {
  'use strict';

  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildTOC() {
    var article = document.querySelector('.ls-article');
    if (!article) return;
    var body = article.querySelector('.article-body');
    var toc = article.querySelector('[data-ls-toc]');
    if (!body || !toc) return;

    var headings = body.querySelectorAll('h2, h3');
    if (!headings.length) {
      toc.setAttribute('hidden', '');
      return;
    }

    var seen = {};
    var list = document.createElement('ol');
    list.className = 'ls-toc__list';

    headings.forEach(function (h) {
      var base = h.id || slugify(h.textContent);
      if (!base) base = 'section';
      var id = base;
      var n = 2;
      while (seen[id]) {
        id = base + '-' + n;
        n += 1;
      }
      seen[id] = true;
      h.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      li.appendChild(a);

      if (h.tagName === 'H2') {
        list.appendChild(li);
      } else {
        var lastTopItem = list.lastElementChild;
        if (lastTopItem) {
          var sub = lastTopItem.querySelector('ol.ls-toc__sublist');
          if (!sub) {
            sub = document.createElement('ol');
            sub.className = 'ls-toc__sublist';
            lastTopItem.appendChild(sub);
          }
          sub.appendChild(li);
        } else {
          list.appendChild(li);
        }
      }
    });

    toc.appendChild(list);

    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
      toc.removeAttribute('open');
    } else {
      toc.setAttribute('open', '');
    }
  }

  /* Mobile only: this theme's site header is sticky/fixed at the top of the
     viewport. The theme's auto-padding script gates on a body class that
     isn't set for our template, so the full-width hero would otherwise sit
     behind the header. Apply a top padding equal to header height on mobile
     so the hero clears the navigation. */
  function adjustArticleTopPadding() {
    var article = document.querySelector('.ls-article');
    if (!article) return;
    if (window.innerWidth > 991) {
      article.style.paddingTop = '';
      return;
    }
    var header = document.querySelector('.header-new');
    if (!header) return;
    article.style.paddingTop = header.offsetHeight + 'px';
  }

  function init() {
    buildTOC();
    adjustArticleTopPadding();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', adjustArticleTopPadding);
  window.addEventListener('resize', adjustArticleTopPadding);
  window.addEventListener('orientationchange', adjustArticleTopPadding);
})();
